/**
 * uniapp相关封装方法
 */
import store from 'store'
import { Loading, Message, MessageBox } from 'element-ui'
import axios from 'axios'
import {
	$callapi
} from './request.js'
import {
	Base64
} from './base64.js'
import {
	$LANGTAB
} from '@/config.js'

let _lang = null;

function fail(res) {
	$showModal($t("失败"), res)
	console.log(res.errMsg)
}
export function $t(str) {
	// 翻译
	let t = $LANGTAB.table && str in $LANGTAB.table ? $LANGTAB.table[str] : str;
	for (let i = 1; i < arguments.length; ++i) {
		t = t.replace('{' + (i - 1) + '}', arguments[i]);
	}
	return t;
}
export function $p(val, ex, showSymbol=true) {
	// 资金转换，ex为汇率对象，不传使用系统设定
	let mt = $getMoneyType() || 'CNY';
	let nd = $getStorage('LocalNationalData');
	let mtd = nd.exMap[mt];
	if (mtd) {
		let nval = val;
		let rt = mtd.rate;
		if (ex && ex[mt]) {
			let rt = ex[mt]
		}
		if (mtd.reverse) {
			nval /= rt
		}
		else if (rt) {
			nval *= rt
		}
		nval = Math.floor(nval * 100 + 0.5) / 100.0;
		// console.log("mt:",mt)
		// console.log("nval:",nval)
		// 如果是越南币，就去除小数部分，并且保留到千位，每3位用,号隔开
		if (mt == "VND"){
			nval = Math.floor(nval)
			// console.log("int nval:", nval)
			nval = String(nval)
			// console.log("str nval:", nval)
			let result = '';
			let count = 0;
			for (let i=nval.length-1; i>=0; i--){
				count++;
                let str = nval[i]
				if (i>nval.length-4){
					str = 0
				}

				if(count % 3 === 0 && i > 0){
					result = ',' + str + result
				}else{
					result = str + result
				}
				
			}
			nval = result
			// result = result.slice(0, -1)
			console.log("result:", result)
		}
		if(!showSymbol){
			return nval
		}
		return mtd.symbol + nval;
	}
	if(!showSymbol){
		return val
	}
	return '￥' + val;
}
export function $transCNY(val){
	let mt = $getMoneyType() || 'CNY';
	let nd = $getStorage('LocalNationalData');
	let mtd = nd.exMap[mt];
	if (mtd) {
		let nval = val;
		let rt = mtd.rate;
		if (mtd.reverse) {
			nval *= rt
		} else if (rt) {
			nval /= rt
		}
		nval = Math.floor(nval * 100 + 0.5) / 100.0;
		// 如果是越南币，就去除小数部分，并且保留到千位，每3位用,号隔开
		return nval;
	}
	return val;
}
export function $getLang() {
	// 获取语言设置
	if (_lang === null) {
		_lang = $getStorage('lang') || ''
	}
	return _lang
}

export function $setLang(lang) {
	// 设置语言设置
	_lang = lang
	console.log('change lang', lang)
	return $setStorage('lang', lang)
}

export function $getMoneyType() {
	// 获取币种设置
	return $getStorage('MoneyType')
}

export function $setMoneyType(type) {
	// 设置币种设置
	console.log('change money type', type)
	return $setStorage('MoneyType', type)
}

export function $getArea() {
	// 获取区域设置
	return $getStorage('Area')
}

export function $setArea(a) {
	// 设置区域设置
	console.log('change area ', a)
	return $setStorage('Area', a)
}

export function $getFlightID() {
	// 获取航班ID
	return $getStorage('FlightID')
}

export function $setFlightID(a) {
	// 设置航班ID
	return $setStorage('FlightID', a)
}

export function $getCurrentPage() {
	return window.location.hash.match(/#([^?]+)/)[1]
}

// mask 透明蒙版，为防止穿透
export function $showToast(title, type) {
	// icon: success loading none
	// console.log("$showToast", title, type);
	const options = typeof (title) === 'string' ? {
		message: title,
		type: type || 'info',
	} : title
	new Message(options)
}

export function $hideToast(title, mask = false) {
	console.log('done')
}

const _loading_instances = []
export function $showLoading(text = $t("请稍等..."), mask = true) {
	// console.log('$showLoading', text)
	if (!text) { text = this.$t('正在加载...') }
	if (!_loading_instances.length) {
		_loading_instances.push(Loading.service({
			lock: true,
			text: text
			// background: 'rgba(0, 0, 0, 0.7)'
		}))
	}
	else {
		_loading_instances[0].$data.text = text
	}
	// console.log(_loading_instances)
}

export function $hideLoading() {
	// console.log('$hideLoading')
	_loading_instances.map(ins => {
		ins.close()
	})
	_loading_instances.splice(0, _loading_instances.length)
}

export function $showModal(title = $t("提示"), content, confirmAction, cancelAction, cancel = true, cancelText = $t("取消"), confirmText = $t("确认"), cancelColor = "#000000", confirmColor = "#34B66B") {
	console.log("未实现$showModal");
	return;
	// uni.showModal({
	// 	title: title,
	// 	content: content,
	// 	cancel: cancel,
	// 	cancelText: cancelText,
	// 	confirmText: confirmText,
	// 	cancelColor: cancelColor,
	// 	confirmColor: confirmColor,
	// 	success: function (res) {
	// 		if (res.confirm && confirmAction) {
	// 			confirmAction()
	// 		} else if (res.cancel && cancelAction) {
	// 			cancelAction()
	// 		}
	// 	},
	// 	fail: res => console.log(res),
	// })
}

export function $showActionSheet(itemList = [], successAction = () => { }, completeAction = () => { }) {
	console.log("未实现$showActionSheet");
	return;
	// uni.showActionSheet({
	// 	itemList: itemList,
	// 	success: res => successAction(res.tableIndex), // 返回从上至下的索引
	// 	fail: res => { },
	// 	complete: res => completeAction(res)
	// })
}

export async function $getAreaAddress(lat, lng) {
	let res = await $callapi("getAreaAddress", {
		'latitude': lat,
		'longitude': lng
	})
	return res
}

export async function $getCurrentLocation() {
	// 获取用户当前位置,优先GPS定位,失败则IP定位
	console.log("未实现$getCurrentLocation");
	return;
	// return await new Promise((resolve, reject) => {
	// 	let next = (lat, lng) => {
	// 		$callapi("getAreaAddress", {
	// 			'latitude': lat,
	// 			'longitude': lng
	// 		}).then((res) => {
	// 			if (res && res.data) {
	// 				resolve(res)
	// 			} else {
	// 				resolve(res);
	// 			}
	// 		}).catch(err => resolve(err));
	// 	}
	// 	uni.getLocation({
	// 		type: 'wgs84',
	// 		success: (lres) => {
	// 			console.log('GPS定位...', lres);
	// 			next(lres.latitude, lres.longitude);
	// 		},
	// 		fail: (res) => {
	// 			// 失败，通过经纬度获取
	// 			console.log('IP定位...');
	// 			next(0, 0);
	// 		}
	// 	});
	// });
}

export async function $errtoast(text = "网络错误,请稍后再试") {
	return $showToast(text, "error")
}

export async function $toast(text, type) {
	return $showToast(text, type)
}

export function $goTo(url) {
	if (url.indexOf('://') >= 0) {
		window.location.href = url;
	}
	else {
		window.location.hash = url;
	}
}

export function $redirectTo(url) {
	return $goTo(url);
}

export async function $msg(text, title) {
	// 显示提示框
	try {
		await this.$alert(text, title || $t('提示'), {
			confirmButtonText: $t('确定'),
		});
		return true;
	}
	catch (e) {
		return false;
	}
}

export async function $query(text, title) {
	// 显示询问框
	if (!title)
		title = $t("提示")
	try {
		return await this.$confirm(text, title, {
			confirmButtonText: $t('确定'),
			cancelButtonText: $t('取消'),
			type: 'warning',
			// center: true,
			closeOnClickModal:false

		}) ? true : false;
	}
	catch (e) {
		return false;
	}
}

export function $back(success = null) {
	window.history.go(-1)
}

// 数据缓存
export function $setStorage(key, data) {
	window.localStorage[key] = JSON.stringify(data)
	// uni.setStorageSync(key, data)
}

export function $getStorage(key) {
	try {
		return JSON.parse(window.localStorage[key])
	}
	catch (e) {
		return null
	}
	// return uni.getStorageSync(key)
}

export function $removeStorage(key) {
	delete window.localStorage[key]
	// uni.removeStorageSync(key)
}

export function $clearStorage(key) {
	window.localStorage.clear()
	// uni.clearStorageSync()
}

export function $getStorageInfo() {
	return null;
	// return uni.getStorageInfoSync()
}

export function $downloadSaveImage(url) {
	return $downloadSaveFile({
		url: url,
		isImage: true,
	})
}
export function $downloadSaveFile({
	url,
	isImage,
	title,
	fileType,
	open,
	share,
}) {
	$toast(isImage ? "请长按图片保存!" : "正在打开...").then(r => {
		if (window && window.location && window.location.href) {
			window.location.href = url
		}
	})
}

export async function $chooseVideo(param = {}) {
	console.log("未实现$chooseVideo");
	return;
	// return await new Promise((resolve, reject) => {
	// 	uni.chooseVideo({
	// 		count: param.count || 1,
	// 		compressed: param.compressed || false,
	// 		maxDuration: param.maxDuration || 60,
	// 		camera: param.camera || 'back',
	// 		sourceType: param.sourceType || ['album', 'camera'],
	// 		success: (res) => resolve(res),
	// 		fail: err => {
	// 			resolve()
	// 		}
	// 	})
	// })
}

export function $viewImage(imgs, index = 0) {
	console.log("未实现$viewImage");
	return;

	// if (!Array.isArray(imgs)) {
	// 	imgs = [imgs]
	// }
	// let actions = [{
	// 	title: '保存图片',
	// 	action: (img) => {
	// 		this.$downloadSaveImage(img)
	// 	}
	// }]
	// uni.previewImage({
	// 	current: index,
	// 	urls: imgs,
	// 	longPressActions: {
	// 		itemList: actions.map(r => r.title), // ['发送给朋友', '保存图片', '收藏'],
	// 		success: function (data) {
	// 			console.log('选中了第' + (data.tapIndex + 1) + '个按钮,第' + (data.index + 1) + '张图片');
	// 			if (data.tapIndex < actions.length) {
	// 				actions[data.tapIndex].action(imgs[data.index]);
	// 			}
	// 		},
	// 		fail: function (err) {
	// 			console.log(err.errMsg);
	// 		}
	// 	}
	// });
}
let _tempfile_map = {};
export async function $chooseFiles(options) {
	if (!options)
		options = {};
	let count = options && options.count || 1;
	let eleid = 'inpid-' + (options.filetype || '') + '-' + (count);
	var fileinp = window.document.getElementById(eleid)
	if (!fileinp) {
		fileinp = window.document.createElement('input')
		fileinp.id = 'uploaderInput'
		fileinp.type = 'file'
		fileinp.style.display = 'none'
		fileinp.accept = options.filetype
		window.document.body.appendChild(fileinp)
	}
	let callback = null;
	let clearTimer = setTimeout(() => {
		callback && callback(null);
	}, 10000);
	fileinp.onchange = function (event) {
		let files = event.target.files;
		let res = files.length ? { path: null, tempFilePaths: [] } : null;
		for (let i = 0; i < files.length; ++i) {
			let f = files[i];
			let tpu = window.URL.createObjectURL(f);
			_tempfile_map[tpu] = f;
			res.tempFilePaths.push(tpu);
		}
		if (res && res.tempFilePaths) {
			res.path = res.tempFilePaths[0];
		}
		callback(res);
		callback = null;
		clearTimeout(clearTimer);
	}
	fileinp.click()
	return await new Promise((resolve, reject) => {
		callback = resolve;
	})
}
export async function $chooseImages(options) {
	return $chooseFiles(Object.assign({
		filetype: 'image/*'
	}, options));
}


export async function $uploadFiles(tempFilePaths) {
	// 将临时文件上传
	if (!Array.isArray(tempFilePaths)) {
		tempFilePaths = [tempFilePaths]
	}
	let rdata = null;
	let _uploadFile = async (data, filepath) => {
		let f = _tempfile_map[filepath];
		let formData = new FormData()
		formData.append('token', data.token)
		formData.append('file', f)
		this.$doing(this.$t('正在上传...'))
		try {
			let respnse = await axios.post(data.action, formData, {
				progress: (e) => {
					if (e.loaded < e.total) {
						// this.$done()
						this.$doing(this.$t('正在上传...{0}%', String(Math.floor(e.loaded / e.total * 100))))
					}
				},
				onUploadProgress: e => {
					if (e.loaded < e.total) {
						// this.$done()
						this.$doing(this.$t('正在上传...{0}%', String(Math.floor(e.loaded / e.total * 100))))
					}
				}
			});
			let res = respnse.data;
			return res && res.length ? res[0] : null;
		}
		catch (e) {
			console.error(e);
		}
	};
	this.$doing(this.$t("正在上传..."));
	rdata = await this.$callapi("getUploadToken");
	let ress = [];
	for (var i = 0; i < tempFilePaths.length; ++i) {
		let r = await _uploadFile(rdata.data, tempFilePaths[i])
		if (r)
			ress.push(r)
	}
	this.$done();
	return ress;
}

import geo from './geo.js'
export default {
	install(Vue) {
		Vue.prototype.$t = $t
		Vue.prototype.$p = $p
		Vue.prototype.$transCNY = $transCNY
		Vue.prototype.$toast = $toast
		Vue.prototype.$errtoast = $errtoast
		Vue.prototype.$goTo = Vue.prototype.$goto = $goTo
		Vue.prototype.$redirectTo = $redirectTo
		Vue.prototype.$back = $back
		Vue.prototype.$query = $query
		Vue.prototype.$msg = $msg
		Vue.prototype.$showActionSheet = $showActionSheet
		Vue.prototype.$setStorage = $setStorage
		Vue.prototype.$getStorage = $getStorage
		Vue.prototype.$getCurrentLocation = $getCurrentLocation
		Vue.prototype.$downloadSaveImage = $downloadSaveImage
		Vue.prototype.$downloadSaveFile = $downloadSaveFile
		Vue.prototype.$viewImage = $viewImage
		Vue.prototype.$getCurrentPage = $getCurrentPage
		Vue.prototype.$chooseImages = $chooseImages
		Vue.prototype.$chooseVideo = $chooseVideo
		Vue.prototype.$uploadFiles = $uploadFiles
		Vue.prototype.$uploadImage = async function () {
			// 上传单个图片
			let f = await this.$chooseImages()
			let s = f ? await this.$uploadFiles(f.tempFilePaths) : null
			return s && s.length ? s[0] : null;
		}
		Vue.prototype.$doing = $showLoading;
		Vue.prototype.$done = $hideLoading;
		Vue.prototype.$getAreaAddress = $getAreaAddress;
		Vue.prototype.$getLang = $getLang
		Vue.prototype.$setLang = $setLang
		Vue.prototype.$getMoneyType = $getMoneyType
		Vue.prototype.$setMoneyType = $setMoneyType
		Vue.prototype.$getArea = $getArea
		Vue.prototype.$setArea = $setArea
		Vue.prototype.$getFlightID = $getFlightID
		Vue.prototype.$setFlightID = $setFlightID
		Vue.prototype.$refresh = function () {
			// 刷新当前页
			window.location.reload();
		};

		Vue.prototype.$call = function (phone) {
			console.log("未实现$call");
			return;
			// uni.makePhoneCall({
			// 	phoneNumber: phone,
			// 	fail: function (e) {
			// 		// console.log(e)
			// 	}
			// });
		}

		Vue.prototype.$toTop = function () {
			console.log("未实现$toTop");
			return;
			// uni.pageScrollTo({
			// 	scrollTop: 0
			// })
		}

		Vue.prototype.$contact1 = function ({
			user,
			send
		}) {
			console.log("未实现$contact1");
			return;

			// let sendURl = ""
			// if (send) {
			// 	send.content.content = this.$substring(send.content.content, 32)
			// 	sendURl = "&send=" + encodeURIComponent(JSON.stringify(send))
			// }
			// uni.navigateTo({
			// 	url: '/pages/chat/chat?target=' + user.id + sendURl,
			// 	success: res => { },
			// 	fail: () => { },
			// 	complete: () => { }
			// });
		}

		Vue.prototype.$toChart = function (id) {
			return this.$goTo('/pages/chat/chat?target=' + id)
		}

		Vue.prototype.$contact = function (user, phone) {
			/**
			 * @param {Object} user 可以传user或者userID，
			 * @param {String} phone 用户电话
			 */
			if (!user && !phone) {
				return console.log(user, phone, "参数错误");
			}

			if (!user && phone) {
				return this.$call(phone)
			}
			if (user && !phone && !user.phone) {
				return this.$toChart(user.id ? user.id : user)
			}
			console.log("未实现$contact");
			return;

			// uni.showActionSheet({
			// 	itemList: ['在线沟通', '电话联系'],
			// 	itemColor: '#3E91FF',
			// 	success: async ({
			// 		tapIndex
			// 	}) => {
			// 		if (tapIndex == 0) {
			// 			this.$toChart(user.id ? user.id : user)
			// 		} else {
			// 			this.$call(phone || user.phone)
			// 		}
			// 	},
			// 	fail: (err) => {
			// 		console.log(err)
			// 	}
			// });
		}

		Vue.prototype.$toNavigate = function (longitude, latitude, name) {
			console.log("未实现$toNavigate");
			return;

			// let gll = geo.wgs84togcj02(longitude, latitude)

			// uni.openLocation({
			// 	latitude: gll[1],
			// 	longitude: gll[0],
			// 	name: name
			// })
		}

		Vue.prototype.$choicesToMap = function (choices, temp) {
			let mp = {}
			if (!temp)
				temp = '{key}'
			choices.map(r => {
				mp[temp.replace('{key}', r[0])] = r[1]
			})
			return mp
		}
		Vue.prototype.$openWeb = function ({
			url,
			title,
			redirect
		}) {
			console.log(url);
			window.location.href = url;
		}
		Vue.prototype.$base64 = Base64;
		Vue.prototype.$encodeData = function (data) {
			return encodeURIComponent(this.$base64.encode(JSON.stringify(data)))
		}
		Vue.prototype.$decodeData = function (data) {
			return JSON.parse(this.$base64.decode(decodeURIComponent(data)))
		}
		// Vue.prototype.$prompt = async function (option) {
		// 	let p = this.$refs.prompt;
		// 	if (!p) {
		// 		throw '未注入组件 <ir-prompt ref="prompt" />'
		// 	}
		// 	let t = await p.open(option)
		// 	return t
		// }
		Vue.prototype.$selectLang = async function (option) {
			// 选择语言
			let r = await this.$selectData('/pages/mine/nationalSetting?selectWith=lang')
			setTimeout(() => {
				this.$nextTick(() => {
					this.$forceUpdate()
				})
			}, 1000)
			return r
		}
		Vue.prototype.$selectArea = async function (option) {
			// 选择区域
			return await this.$selectData('/pages/mine/nationalSetting?selectWith=area')
		}
		Vue.prototype.$selectMoneyType = async function (option) {
			// 选择币种
			return await this.$selectData('/pages/mine/nationalSetting?selectWith=monetype')
		}
	}
}
